import type { RouteRecordRaw, RouteComponent } from 'vue-router'
import type { RouteMiddleware } from '#app'
import { PageTypes } from '@core/constants/pages'
import { MONEY_TRANSFER } from '@gifsa/language-utils/routes'

export function getTransferRoutes(
  component: RouteComponent,
  middleware: RouteMiddleware,
): RouteRecordRaw[] {
  return [
    ...MONEY_TRANSFER.map(
      ({ url, lang }): RouteRecordRaw => ({
        name: `transfer-partial-${lang}`,
        path: joinRoute(url, ':countryFrom', ':countryTo', ':amount?'),
        meta: { pageType: PageTypes.TRANSFER, lang, middleware },
        component,
      }),
    ),
    ...MONEY_TRANSFER.map(
      ({ url, lang }): RouteRecordRaw => ({
        name: `transfer-${lang}`,
        path: joinRoute(
          url,
          ':countryFrom',
          ':countryTo',
          ':currencyFrom',
          ':currencyTo',
          ':amount?',
        ),
        meta: { pageType: PageTypes.TRANSFER, lang, middleware },
        component,
      }),
    ),
  ]
}
